<div class="irembogov-json-diff-viewer">
  <!-- Waiting for parent to finish loading comparison data -->
  <div *ngIf="loading" class="diff-loading">
    <div class="diff-loading__spinner"></div>
    <span class="diff-loading__text">Loading comparison data...</span>
  </div>

  <!-- Computing diff -->
  <div *ngIf="!loading && isComputing && !splitResult" class="diff-loading">
    <div class="diff-loading__spinner"></div>
    <span class="diff-loading__text">Computing diff...</span>
  </div>

  <ng-container *ngIf="splitResult && propResult">
    <!-- Summary bar -->
    <div
      class="diff-summary-bar d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <span class="fw-semibold me-3" *ngIf="sectionTitle">{{
          sectionTitle
        }}</span>
        <ng-container *ngIf="hasDifferences">
          <span class="summary-badge added" *ngIf="propResult.addedCount">
            +{{ propResult.addedCount }} added
          </span>
          <span class="summary-badge removed" *ngIf="propResult.missingCount">
            -{{ propResult.missingCount }} removed
          </span>
          <span class="summary-badge modified" *ngIf="propResult.unequalCount">
            ~{{ propResult.unequalCount }} modified
          </span>
        </ng-container>
        <span class="summary-badge unchanged" *ngIf="!hasDifferences"
          >No changes</span
        >
      </div>

      <!-- Navigation controls -->
      <div class="diff-nav">
        <ng-container *ngIf="changeGroups.length > 0">
          <button
            class="diff-nav-counter diff-nav-counter--clickable"
            (click)="goToChange(currentChangeIndex)"
            title="Jump to current change">
            Change {{ currentChangeIndex + 1 }} of {{ changeGroups.length }}
          </button>
          <button
            class="diff-nav-btn"
            (click)="prevChange()"
            [disabled]="currentChangeIndex <= 0"
            title="Previous change">
            &#9650;
          </button>
          <button
            class="diff-nav-btn"
            (click)="nextChange()"
            [disabled]="currentChangeIndex >= changeGroups.length - 1"
            title="Next change">
            &#9660;
          </button>
        </ng-container>
        <span class="small text-muted ms-2">
          {{ splitResult.summary.totalChanges }} line{{
            splitResult.summary.totalChanges === 1 ? '' : 's'
          }}
          changed
        </span>
      </div>
    </div>

    <!-- Split diff panels -->
    <div class="diff-split">
      <!-- Left: Old -->
      <div class="diff-half">
        <div class="diff-panel-label">{{ effectiveOldLabel }}</div>
        <div class="diff-panel-scroll" #oldPanel>
          <div class="diff-virtual-spacer" [style.height.px]="totalHeight">
            <table
              class="diff-table diff-table--virtual"
              [style.transform]="'translateY(' + topOffset + 'px)'">
              <thead class="visually-hidden">
                <tr>
                  <th>Line</th>
                  <th>Code</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let vl of visibleLines; trackBy: trackByIndex"
                  [class]="getOldCellClass(vl.line)"
                  [class.diff-row-active-group]="isInActiveGroup(vl.index)"
                  [class.diff-row-commentable]="enableLineComment">
                  <td class="line-num">
                    <button
                      *ngIf="enableLineComment"
                      class="diff-add-comment-btn"
                      title="Add comment"
                      (click)="onAddLineComment($event, vl)">
                      +
                    </button>
                    {{ vl.line.oldNum ?? '' }}
                  </td>
                  <td class="line-code">{{ vl.line.oldLine ?? '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Right: New -->
      <div class="diff-half">
        <div class="diff-panel-label">{{ newLabel }}</div>
        <div class="diff-panel-scroll" #newPanel>
          <div class="diff-virtual-spacer" [style.height.px]="totalHeight">
            <table
              class="diff-table diff-table--virtual"
              [style.transform]="'translateY(' + topOffset + 'px)'">
              <thead class="visually-hidden">
                <tr>
                  <th>Line</th>
                  <th>Code</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let vl of visibleLines; trackBy: trackByIndex"
                  [class]="getNewCellClass(vl.line)"
                  [class.diff-row-active-group]="isInActiveGroup(vl.index)"
                  [class.diff-row-commentable]="enableLineComment">
                  <td class="line-num">
                    <button
                      *ngIf="enableLineComment"
                      class="diff-add-comment-btn"
                      title="Add comment"
                      (click)="onAddLineComment($event, vl)">
                      +
                    </button>
                    {{ vl.line.newNum ?? '' }}
                  </td>
                  <td class="line-code">{{ vl.line.newLine ?? '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
